require('angular');

angular.module('app').controller('carticonController', CarticonController);
CarticonController.$inject = ['$http', '$scope','$rootScope', '$sce', '$window'];

function CarticonController($http, $scope,$rootScope, $sce, $window) {
    $scope.counter         = [];
    $scope.fetchCount      = function(){
        $http({
            method: 'POST',
            async: false,
            dataType: 'json',
            url: '/wp-admin/admin-ajax.php',
            params: {
                action: 'fetch-basket-counter'
            }
        }).then(function(data){
            $scope.counter = parseInt(data.data);
        });
    }

    $rootScope.$on('removeBasketItem', function () {
        $scope.counter --;
    });
}